const reportHubPage = require("./reportHub-page");

export function start(detail) {
  obj[detail.elem].start(detail);
}

const obj = {
  page: {
    start: (detail) => {
      reportHubPage.start(detail);
    },
  },
};
